import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Facebook, Linkedin, Instagram } from "lucide-react";
import Logo from "./Logo";
import { company, categories } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-[#0A1E3A] text-gray-300 pt-16 pb-6">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            <Logo variant="light" />
            <p className="mt-5 text-sm leading-relaxed text-gray-400">
              Il tuo partner per ferramenta, utensileria, antinfortunistica,
              materiale ferroso e servizi di manutenzione e logistica.
            </p>
            <div className="flex items-center gap-3 mt-6">
              {[
                { name: "Facebook", Icon: Facebook },
                { name: "LinkedIn", Icon: Linkedin },
                { name: "Instagram", Icon: Instagram },
              ].map(({ name, Icon }) => (
                <a
                  key={name}
                  href="#"
                  aria-label={name}
                  className="w-9 h-9 rounded-full border border-gray-700 hover:border-[#00A859] hover:text-[#00A859] hover:bg-[#00A859]/10 flex items-center justify-center transition-colors"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold uppercase tracking-wider text-sm mb-5">
              Prodotti
            </h4>
            <ul className="space-y-2.5 text-sm">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link
                    to={`/prodotti/${c.slug}`}
                    className="hover:text-[#00A859] transition-colors"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold uppercase tracking-wider text-sm mb-5">
              Azienda
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/chi-siamo" className="hover:text-[#00A859] transition-colors">Chi siamo</Link></li>
              <li><Link to="/servizi" className="hover:text-[#00A859] transition-colors">Servizi</Link></li>
              <li><Link to="/cataloghi" className="hover:text-[#00A859] transition-colors">Cataloghi</Link></li>
              <li><Link to="/news" className="hover:text-[#00A859] transition-colors">News & Novità</Link></li>
              <li><Link to="/contatti" className="hover:text-[#00A859] transition-colors">Contatti</Link></li>
              <li><a href="#" className="hover:text-[#00A859] transition-colors">Lavora con noi</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold uppercase tracking-wider text-sm mb-5">
              Contatti
            </h4>
            <ul className="space-y-3 text-sm">
              <li className="flex gap-3">
                <MapPin className="w-4 h-4 text-[#00A859] mt-0.5 shrink-0" />
                <div>
                  <div className="font-semibold text-white text-xs uppercase tracking-wide mb-0.5">Sede legale</div>
                  {company.address}<br />{company.city}<br />{company.country}
                </div>
              </li>
              <li className="flex gap-3">
                <MapPin className="w-4 h-4 text-[#00A859] mt-0.5 shrink-0" />
                <div>
                  <div className="font-semibold text-white text-xs uppercase tracking-wide mb-0.5">{company.warehouse.label}</div>
                  {company.warehouse.address}<br />{company.warehouse.city}
                </div>
              </li>
              <li>
                <a href={`tel:${company.telRaw}`} className="flex items-center gap-2 hover:text-[#00A859] transition-colors">
                  <Phone className="w-4 h-4 text-[#00A859]" /> {company.tel}
                </a>
              </li>
              <li>
                <a href={`mailto:${company.email}`} className="flex items-center gap-2 hover:text-[#00A859] transition-colors break-all">
                  <Mail className="w-4 h-4 text-[#00A859] shrink-0" /> {company.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 flex flex-wrap items-center justify-between gap-4 text-xs text-gray-500">
          <div>
            &copy; {new Date().getFullYear()} {company.name} — P.IVA {company.vat} — CF {company.cf}
          </div>
          <div className="flex gap-5">
            <a href="#" className="hover:text-[#00A859] transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-[#00A859] transition-colors">Cookie Policy</a>
            <a href="#" className="hover:text-[#00A859] transition-colors">Termini e Condizioni</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
